import { Container, Sprite, Text, type Texture } from 'pixi.js';

// Shared textured button. The texture is scaled UNIFORMLY to `height` (width
// follows the texture aspect) so ornate end-caps never stretch - matching the
// SELECT button and avoiding the squish you get from setting width/height
// independently. Content is centered on the container origin, so position the
// returned button by its center.
const PRESS_SCALE = 0.95;

export type ImageButtonOptions = {
  texture: Texture;
  label: string;
  // Target height in design px; width follows the texture aspect.
  height: number;
  fontFamily?: string;
  fontSize: number;
  textColor: number;
  textResolution: number;
  letterSpacing?: number;
  onTap: () => void;
};

export function makeImageButton(opts: ImageButtonOptions): Container {
  const btn = new Container();

  const bg = new Sprite(opts.texture);
  bg.anchor.set(0.5);
  bg.scale.set(opts.height / opts.texture.height);
  btn.addChild(bg);

  const label = new Text({
    text: opts.label,
    style: {
      fontFamily: opts.fontFamily,
      fontSize: opts.fontSize,
      fontWeight: 'bold',
      fill: opts.textColor,
      letterSpacing: opts.letterSpacing ?? 0,
    },
    resolution: opts.textResolution,
  });
  label.anchor.set(0.5);
  btn.addChild(label);

  btn.eventMode = 'static';
  btn.cursor = 'pointer';
  btn.on('pointerdown', () => btn.scale.set(PRESS_SCALE));
  btn.on('pointerup', () => btn.scale.set(1));
  btn.on('pointerupoutside', () => btn.scale.set(1));
  btn.on('pointertap', opts.onTap);
  return btn;
}
